export default {
  condiciones: state => state.condiciones,
  condicionActual: state => state.condicionActual,

  horas: state => state.horas,
  horaActual: state => state.horaActual,
  horasSinLiquidar: state => state.horas.filter(h => !h.esta_liquidado),

  liquidaciones: state => state.liquidaciones,
  liquidacionActual: state => state.liquidacionActual,

  liquidacionesEnBorrador: state => state.liquidaciones.filter(l => l.estado === 'borrador'),
  liquidacionesConfirmadas: state => state.liquidaciones.filter(l => l.estado === 'confirmada'),
  liquidacionesAnuladas: state => state.liquidaciones.filter(l => l.estado === 'anulada'),
};
